import * as React from "react";
import {
  WheelPicker,
  WheelPickerOption,
  WheelPickerWrapper,
} from "./wheel-picker";

const createArray = (length: number, add = 0): WheelPickerOption<number>[] =>
  Array.from({ length }, (_, i) => {
    const value = i + add;
    return {
      label: value.toString().padStart(2, "0"),
      value: value,
    };
  });

const monthOptions: WheelPickerOption<number>[] = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const dayOptions = createArray(31, 1);
const yearOptions = createArray(100, new Date().getFullYear() - 50);

interface DateSelectWheelProps {
  onChange?: (date: string) => void;
}

export function DateSelectWheel({ onChange }: DateSelectWheelProps) {
  const today = new Date();
  const [month, setMonth] = React.useState(today.getMonth() + 1);
  const [day, setDay] = React.useState(today.getDate());
  const [year, setYear] = React.useState(today.getFullYear());

  React.useEffect(() => {
    if (onChange) {
      // Format date as "Nov 26, 2025"
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const formattedDate = `${monthNames[month - 1]} ${day}, ${year}`;
      onChange(formattedDate);
    }
  }, [month, day, year, onChange]);

  return (
    <div className="w-full">
      <WheelPickerWrapper className="bg-transparent border-none ">
        <WheelPicker
          options={monthOptions}
          defaultValue={month}
          onValueChange={(value: number) => setMonth(value)}
          infinite
          // visibleCount={10}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
        />
        <WheelPicker
          options={dayOptions}
          defaultValue={day}
          onValueChange={(value: number) => setDay(value)}
          infinite
          // visibleCount={10}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
        />
        <WheelPicker
          options={yearOptions}
          defaultValue={year}
          onValueChange={(value: number) => setYear(value)}
          // visibleCount={10}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
        />
      </WheelPickerWrapper>
    </div>
  );
}
